<template>
    <Page :is-loading="isPageLoading" :page-code="pageCode" @reload="loadPage">
        <div v-if="orderMaster.name" class="page-body">
            <Panel>
                <span slot="title">
                    <i class="iconfont icon-doctoral-cap fs20px top2px" /> {{orderMaster.name}}
                </span>
                <VanForm validate-first label-width="55px" @submit="handleSubmit">
                    <VanField v-model="mobile" type="digit" size="large" maxlength="11"
                              clearable center class="mobile-field"
                              label="手机号" placeholder="请输入米德云课堂登录手机号"
                              :rules="[{required: true}, {pattern: /1\d{10}/, message: '手机号格式不正确'}]" />
                    <VanButton round block :type="isWxBrowser ? 'primary' : 'info'" class="mt1rem">
                        查询交费
                    </VanButton>
                    <div class="txt-center txt-gray fs12px mt1rem">每天最多可查询15次</div>
                </VanForm>
            </Panel>
            <Panel v-if="studentOrders.length > 0" hide-header>
                <div class="mb1rem txt-label">
                    <i class="iconfont icon-search-result fs17px top1px" /> 查询结果
                </div>
                <VanCellGroup>
                    <StudentOrder v-for="(so, i) in studentOrders" :student="so.student" :paid="so.paid" :key="i"/>
                </VanCellGroup>
                <div class="txt-center txt-gray fs12px mt1rem">请选择一个学生</div>
            </Panel>
            <Help :link="isWxBrowser ? '/user-doc/米德微信交费中心/index.html' : '/user-doc/米德支付宝交费中心/index.html'">
                输入米德云课堂登录手机号查询交费
            </Help>
        </div>
    </Page>
</template>

<script>
    import Page from '@/components/Page.vue';
    import Panel from '@/components/Panel.vue';
    import Help from '@/components/Help.vue';
    import StudentOrder from '@/pages/fee/components/StudentOrder.vue';
    import PageLoading from '@/mixins/PageLoading';
    import WxPreparing from '@/mixins/WxPreparing';
    import Utils from '@/utils';

    export default {
        name: 'OrderMasterIndex',
        components: {
            StudentOrder, Page, Panel, Help,
        },
        mixins: [PageLoading, WxPreparing],
        data() {
            return {
                mobile: sessionStorage.getItem('MIDE_ORDER_MASTER_MOBILE') || '',
                studentOrders: [],
                orderMaster: {
                    name: '',
                    goodsImage: '',
                },
            };
        },
        async mounted() {
            await this.loadPage();
            await this.hideWxAllMenuItems();
            await this.showWxShareMenuItems();
            await this.showWxCopyUrlMenuItems();
            await this.loadStudents();
        },
        async beforeRouteUpdate(to, from, next) {
            next();
            await this.loadStudents();
        },
        methods: {
            async loadPageData() {
                const res = await this.$api.orderMaster.get(this.$route.params.orderMasterUuid);
                this.orderMaster = res.data.data;
                const imgUrl = Utils.file.getResourceUrl(Utils.string.splitFirst(this.orderMaster.goodsImage));
                await this.updateWxShareMenuItems(imgUrl, this.orderMaster.name, this.orderMaster.description, window.location.href);
            },
            /**
             * 加载查询结果
             */
            async loadStudents() {
                const { mobile } = this.$route.query;
                if (/1\d{10}/.test(mobile)) {
                    this.mobile = mobile;
                    this.studentOrders = [];
                    const res = await this.$api.orderMaster.listStudents(this.$route.params.orderMasterUuid, mobile);
                    this.studentOrders = res.data.data;
                }
            },
            /**
             * 点击查询
             */
            async handleSubmit() {
                const { mobile } = this.$route.query;
                if (mobile === this.mobile) {
                    await this.loadStudents();
                } else {
                    await this.$router.replace({
                        path: this.$route.path,
                        query: { mobile: this.mobile },
                    });
                }
            },
        },
    };
</script>

<style scoped lang="less">
    .mobile-field {
        height: 48px;
        padding-left: 0;
        padding-right: 0;

        &::after {
            display: none;
        }
    }
</style>
